<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Aneks do umowy zlecenie numer {{ numerUmowy }}</strong>
</p>
<p>
    Zawarty pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla
Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod nr KRS: 0000670834, NIP: 727-
28-12-193, REGON: 366891567, kapitał zakładowy 6 481 900,00 zł, reprezentowaną przez:
</p>
<p>
  <strong>{{ zamawiajacy }}</strong>,
</p>
<p>a</p>
  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: {{ imieNazwisko }}
  <br/>
  Pesel: {{ pesel }}
  <br/>
  Adres: {{ zamieszkany }}
  <br/>
  <br/>

<p>Zleceniodawca i Zleceniobiorca zgodnie oświadczają, iż z dniem {{ aktualnaData() }} zmieniają na mocy aneksu
wiążącą ich umowę zlecenie zawartą w dniu {{ dataPodpisania }} r. Poniższe zapisy wchodzą w życie z dniem
01.11.2023.</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong>
</p>
  <p>1) W zakresie umowy zmieniony zostaje zapis dotyczący zakresu czynności wykonywanego zlecenia, strony zgodnie postanawiają, iż § 1 ust. 1 umowy otrzymuje następujące  brzmienie:</p>
    <p style="margin-bottom: 0px;">“1. Na podstawie niniejszej umowy Zleceniodawca zleca, a Zleceniobiorca podejmuje się    
          wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności (zwanych w dalszej 
          części Umowy Zleceniami) jak:</p>
    <ol type="a">
      <li>prowadzenie/ animowanie zajęć dydaktycznych,</li>
      <li>realizacja innych zadań promocyjnych, marketingowych i organizacyjnych,</li>
      <li>sporządzanie raportów i podsumowań z pracy własnej,</li>
      <li>realizacja innych zadań i projektów zleconych przez Zleceniodawcę.”</li>
    </ol>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong>
</p>
  <p>
    1) W zakresie umowy dodany zostanie zapis dotyczący  jednostki obliczeniowej wykonywanego zlecenia, strony zgodnie postanawiają, iż § 2 ust. 6 umowy brzmieć będzie:
  </p>
    <p style="margin-bottom: 0px;">“6. Strony ustalają, iż za jednostkę obliczeniową przyjmuje się:</p>
    <ol type="a">
      <li>w przypadku zleceniobiorców pełniących funkcje dydaktyczne - 45 minut zajęć według ustalonego harmonogramu.</li>
      <li>w przypadku zleceniobiorców pełniących funkcje organizacyjne -60 minut według ustalonego harmonogramu”</li>
    </ol>
  <p>
    2) W zakresie umowy dodany zostanie zapis dotyczący miejsca wykonywania przedmiotu umowy, strony zgodnie postanawiają, iż § 2 ust. 7 umowy brzmieć będzie:
  </p>
    <p>“7. Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się może w formule stacjonarnej    
     w wybranej placówce Zleceniodawcy wskazanej przez Zleceniodawcę albo u Klienta w miejscu   
     wskazanym przez Zleceniodawcę. Forma prowadzenia zajęć określona zostanie w harmonogramie    
    zajęć. Zleceniodawca umożliwi Zleceniobiorcy korzystanie z platform niezbędnych do prowadzenia    
    zajęć.“</p>

  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 3</strong>
  </p>
    <p>
      1) W zakresie umowy zmienione zostają zapisy dotyczące wynagrodzenia ,strony zgodnie postanawiają, iż § 5 umowy otrzymuje następujące  brzmienie:
    </p>
      <span>„1. Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Umowy oraz powierzonych   
     Zleceniobiorcy Zleceń, Zleceniobiorca otrzyma wynagrodzenie  w wysokości:</span>
     <ol type="a">
        <li>usługa “animator zajęcia dydaktyczne” 30 zł (słownie: trzydzieści złotych) brutto za jedną godzinę  rozumianą zgodnie z §2 niniejszego aneksu  (§2 ust. 6 umowy).</li>
        <li>usługa “animator zajęcia organizacyjne” 30 zł (słownie: trzydzieści .złotych) brutto za jedną godzinę  rozumianą zgodnie z §2 niniejszego aneksu  (§2 ust. 6 umowy).</li>
     </ol>
     <span>2. W przypadku Zleceniobiorców świadczących Zlecenie wyszczególnionych w §3 pkt. 1 a.     
  niniejszego aneksu (§ 5 pkt.1 a umowy)) do obliczania wysokości wynagrodzenia dodatkowo   
 zastosowanie ma poniższa Tabela nr.1: <em>Taryfikator stawek dla zajęć stacjonarnych w szkołach  
 podstawowych w projekcie Back to School.</em></span>

      <table class="wage-table">
        <caption>Tabela nr.1 Taryfikator stawek dla zajęć stacjonarnych w szkołach podstawowych w projekcie Back to School</caption>
        <tr>
          <th>Ilość obecnych aktywnych uczestników kursu</th>
          <th>Stawka brutto animator dla kursu stałego 60 min</th>
        </tr>
        <tr 
          v-for="(row,index) in tableRows"
          :key="index"  
        >
          <td>{{ row.studentsNum }}</td>
          <td>{{ row.animatorWage }}</td>
        </tr>
      </table>

    <span>3. Z racji wykonywanych zajęć stacjonarnych w placówkach wskazanych przez Zleceniodawcę zgodnie z  § 2 niniejszego aneksu (§ 2 ust.7 umowy) Zleceniobiorcy nie przysługuje dodatkowe wynagrodzenie z tytułu dojazdu oraz za dokonanie czynności dodatkowych związanych z przygotowaniem, organizacją i raportowaniem zajęć.</span>
    <p style="margin-bottom: 0px;">4.  Za realizację zajęć pokazowych stacjonarnych obowiązuje stawka bazowa.</p>
    <p style="margin-bottom: 0px;">5. Za aktywnego uczestnika zajęć (zz) uważa się osobę obecną minimum na jednych zajęciach stałych, która jest aktywnym płatnikiem.</p>
    <p style="margin-bottom: 0px;">6. Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, 15-tego dnia następnego miesiąca kalendarzowego następującego po miesiącu rozliczenia, w wysokości określonej powyżej, w oparciu o zestawienie, o którym mowa w ust. 9 poniżej, na numer konta bankowego wskazanego przez Zleceniobiorcę.</p>
    <p style="margin-bottom: 0px;">7. Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej:</p>
    <ol class="special">
      <li>zestawienia liczby godzin przepracowanych w danym miesiącu, wygenerowanego z narzędzi do ewidencjonowania godzin udostępnionego przez Zleceniodawcę, najpóźniej w ostatnim dniu roboczym miesiąca.</li>
      <li>prowadzonej dokumentacji potwierdzającej realizację zajęć w danym miesiącu, w szczególności dzienników zajęć i list obecności uczniów, najpóźniej do ostatniego dnia miesiąca, za który Zleceniobiorcy przysługuje wynagrodzenie z tytułu wykonania zlecenia.</li>
    </ol>
    <span>Zweryfikowane przez Zleceniodawcę zestawienie i dokumentacja będą stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.”</span>


<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4</strong>
</p>
<p>1) Pozostałe warunki umowy o współpracy nie ulegają zmianie.</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5</strong>
</p>
<p>1) Niniejszy aneks sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>


<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{ zamawiajacy }}</span><br>
        <span style="margin-left: 0%;">Zleceniodawca</span>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}<br>
        <span style="margin-left: 0%;">Zleceniobiorca</span>
    </div>
</div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'AneksAnimatorTutoreDuze',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      pesel: '',
      zamieszkany: '',
      zmiana: '',
      dataAneks: '',
      numerUmowy: '',
      dataPodpisania: '',
      stawka: '',
      stawkaSlownie: '',
      tableRows: [
        { studentsNum: 'zajęcia pokazowe', animatorWage: '30'},
        { studentsNum: '1-5', animatorWage: '30'},
        { studentsNum: '6', animatorWage: '35'},
        { studentsNum: '7', animatorWage: '40'},
        { studentsNum: '8', animatorWage: '45'},
        { studentsNum: '9', animatorWage: '50'},
        { studentsNum: '10', animatorWage: '55'},
        { studentsNum: '11', animatorWage: '60'},
        { studentsNum: '12', animatorWage: '65'},
        { studentsNum: '13', animatorWage: '70'},
        { studentsNum: '14', animatorWage: '75'},
        { studentsNum: '15 i więcej', animatorWage: '80'},
      ],
    };
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    aktualnaData() {
      const today = new Date();
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = today.getDate()+'-'+month+'-'+today.getFullYear()
      return todayDate
    },
    teacherWage(index) {
      return index > 1 ? Number(this.stawka) + 5 * (index - 1) : this.stawka;
    },
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}

.wage-table {
  border: 1px solid; 
  font-size: 12px; 
  width: 50%;
  margin: 20px;
}

.wage-table caption {
  text-align: left; 
}

.wage-table td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  font-weight: bold;
  text-align: center;
}

ol.special {
    counter-reset: list;
}
ol.special > li {
    list-style: none;
    position: relative;
}
ol.special > li:before {
    counter-increment: list;
    content: counter(list) ") ";
    position: absolute;
    left: -1.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/AneksAnimatorTutoreDuze.vue